<!--  -->
<template>
  <div class="m_header">
    <div class="click" @click="toggerScroll">
      <div class="item">
        <span :class="['dot', { dark: theme === 'dark' }]"></span>
        <span :class="['line', { dark: theme === 'dark' }]"></span>
      </div>
      <div class="item">
        <span :class="['dot', { dark: theme === 'dark' }]"></span>
        <span :class="['line', { dark: theme === 'dark' }]"></span>
      </div>
      <div class="item">
        <span :class="['dot', { dark: theme === 'dark' }]"></span>
        <span :class="['line', { dark: theme === 'dark' }]"></span>
      </div>
    </div>
    <div
      class="popover"
      :class="['scrollin', { popover_ant: scrollin }]"
      id="popover"
    >
      <div class="popover-arrow"></div>
      <div class="popover-inner">
        <ul>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('home')"
              v-if="active === 'true'"
              >首页</a
            >
            <router-link to="/m_index?#home" v-else>首页</router-link>
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('introduction')"
              v-if="active === 'true'"
              >企业介绍</a
            >
            <router-link to="/m_index?#introduction" v-else
              >企业介绍</router-link
            >
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('origin')"
              v-if="active === 'true'"
              >公司名称由来</a
            >
            <router-link to="/m_index?#origin" v-else>公司名称由来</router-link>
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('products')"
              v-if="active === 'true'"
              >专营产品</a
            >
            <router-link to="/m_index?#products" v-else>专营产品</router-link>
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('techCenter')"
              v-if="active === 'true'"
              >图纸下载</a
            >
            <router-link to="/m_index?#techCenter" v-else>图纸下载</router-link>
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('importExport')"
              v-if="active === 'true'"
              >资质证明</a
            >
            <router-link to="/m_index?#importExport" v-else
              >资质证明</router-link
            >
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('partner')"
              v-if="active === 'true'"
              >合作伙伴</a
            >
            <router-link to="/m_index?#partner" v-else>合作伙伴</router-link>
          </li>
          <li @click="scrollin = false">
            <a
              href="javascript:;"
              @click="goAnchor('aboutUs')"
              v-if="active === 'true'"
              >关于我们</a
            >
            <router-link to="/m_index?#aboutUs" v-else>关于我们</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    theme: String,
    active: String,
  },

  data() {
    //这里存放数据
    return {
      scrollin: false,
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {},

  //方法集合
  methods: {
    toggerScroll() {
      this.scrollin = !this.scrollin;
      // const dom = document.getElementById("popover");
      // if (dom) {
      //   if (!dom.contains(event.target)) {
      //     this.scrollin = !this.scrollin;
      //   }
      // }
    },
    // 标签滚动
    goAnchor(selector) {
      document.getElementById(selector).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang='less' scoped>
.m_header {
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  .click {
    .item {
      display: flex;
      margin-bottom: 5px;
      .dot {
        width: 4px;
        height: 4px;
        border-radius: 2px;
        background: #fff;
        &.dark {
          background: rgba(0, 0, 0, 0.8);
        }
      }
      .line {
        width: 30px;
        height: 4px;
        border-radius: 2px;
        margin-left: 4px;
        background: #fff;
        &.dark {
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }

  .popover {
    position: absolute;
    right: -3px;
    top: 30px;
    &.scrollin {
      display: none;
      transition: all 0.3s;
    }
    &.scrollin.popover_ant {
      transition: all 0.3s;
      display: block;
    }

    .popover-arrow {
      position: absolute;
      display: block;
      width: 8.48528137px;
      height: 8.48528137px;
      background: 0 0;
      border-style: solid;
      border-width: 4.24264069px;
      top: -8.2px;
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: rgba(0, 0, 0, 0.8);
      border-left-color: transparent;
      right: 15px;
    }
    .popover-inner {
      ul {
        width: 2.6rem;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 5px;

        li {
          width: 100%;
          text-align: center;
          height: 0.88rem;
          line-height: 0.88rem;
          position: relative;
          // border-bottom: 1PX solid rgba(255, 255, 255, 0.5);
          &::after {
            content: "";
            position: absolute;
            -webkit-transform-origin: center;
            -ms-transform-origin: center;
            transform-origin: center;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            pointer-events: none;
            top: auto;
            left: 0;
            right: 0;
            bottom: 0;
            -webkit-transform: scaleY(0.1);
            -ms-transform: scaleY(0.1);
            transform: scaleY(0.1);
            border-bottom: 1px solid #d6e4ef;
          }
          a {
            display: block;
            width: 100%;
            height: 100%;
            color: #fff;
            font-size: 0.28rem;
          }
        }
      }
    }
  }
}
</style>